export const ConceptosDePagoParaGruposCerradosHeader = [
  {
    accessorKey: "campus",
    header: "Campus",
    enableEditing: false,
    enableGlobalFilter: true,
  },
  {
    accessorKey: "concepto",
    header: "Concepto",
    enableEditing: true,
    enableGlobalFilter: true,
  },
  {
    accessorKey: "escuela",
    header: "Escuela",
    enableEditing: true,
    enableGlobalFilter: true,
  },
  {
    accessorKey: "estatus",
    header: "Estatus",
    enableEditing: false,
    enableGlobalFilter: false,
  },
  {
    accessorKey: "modificado",
    header: "Modificado",
    enableEditing: false,
    enableGlobalFilter: false,
  },
  {
    accessorKey: "modificado_por",
    header: "Modificado Por",
    enableEditing: false,
    enableGlobalFilter: false,
  },
  {
    accessorKey: "creado",
    header: "Creado",
    enableEditing: false,
    enableGlobalFilter: false,
  },
  {
    accessorKey: "creado_por",
    header: "Creado Por",
    enableEditing: false,
    enableGlobalFilter: false,
  },
];
